import React from 'react';
import { Box } from '@landr/maestro';

export const PlaceholderButton: React.FC = () => {
    return <Box width="sm" height="sm" data-testid="placeholder-button" />;
};
